import { SerieData } from '../models/serie-data';

export interface ShareNumberingSeriesRef {
  seriesId?: number | null;
  seriesName?: string;
}

/** Resuelve la serie de capital para una numeración. seriesId autoritativo si resuelve. */
export function findSeriesInCapital(
  sn: ShareNumberingSeriesRef,
  series: SerieData[],
): SerieData | undefined {
  if (sn.seriesId != null) {
    const byId = series.find(s => s.id === sn.seriesId);
    if (byId) return byId;
    const byFeLocal = series.find(s => s.feLocalId === sn.seriesId);
    if (byFeLocal) return byFeLocal;
  }

  const nameKey = sn.seriesName?.trim().toLowerCase() ?? '';
  if (nameKey) {
    return series.find(s => s.name.trim().toLowerCase() === nameKey);
  }

  return undefined;
}

export function reconcileShareNumberingsWithCapital<T extends ShareNumberingSeriesRef>(
  shareNumberings: T[] | undefined | null,
  series: SerieData[],
  hasSeries: boolean,
): T[] {
  if (!hasSeries) {
    return (shareNumberings ?? []).map(sn => ({ ...sn }));
  }
  return (shareNumberings ?? []).map(sn => {
    const match = findSeriesInCapital(sn, series);
    if (!match) return { ...sn };
    return {
      ...sn,
      seriesId: match.id,
      seriesName: match.name,
    };
  });
}
